// AiCardBuilder.jsx  (same structure style as your Card.jsx)
import React, { useLayoutEffect, useState, useEffect } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useAtom } from "jotai";

import { loggedInUser, teamIDCheck } from "../utils/store";
import Loader from "../components/Loader";
import showToast from "../helpers/showToast";
import { trackEvent } from "../utils/mixpanel";

import { Button } from "react-bootstrap";
import { FiPaperclip, FiMic, FiArrowUp } from "react-icons/fi";
import aiLogo from "../assets/images/ai-logo.png";

// (Optional) if you want to hit an API later
// import { post } from "../server";
// import { AI_CARD_BUILDER_URL } from "../utils/constants/apiUrl";

const AiCardBuilder = () => {
  const navigate = useNavigate();
  const { teamId, userId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const team_id = searchParams.get("team_id");
  const user_id = searchParams.get("user_id");
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");

  const [loggedUser] = useAtom(loggedInUser);
  const [userTeamId] = useAtom(teamIDCheck);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // If you navigated with state from modal
  const navState = location.state || {};
  const pageUserName = navState.userName || loggedUser?.name || "Stewart";

  useLayoutEffect(() => {
    // optional: track page view
    trackEvent("ai_card_builder_opened", {
      teamId: teamId || team_id || userTeamId,
      userId: userId || user_id,
      dynamicQRCodeId: dynamicQRCodeId || null,
    });
  }, []);

  const handleSend = async () => {
    if (!message.trim()) return;

    try {
      setLoading(true);

      // TODO: call your api here if required
      // const payload = {
      //   message,
      //   team_id: teamId || team_id || userTeamId,
      //   user_id: userId || user_id,
      //   dynamic_qr_code: dynamicQRCodeId,
      // };
      // const { status, message: msg } = await post(AI_CARD_BUILDER_URL, payload, loggedUser?.token);
      // showToast(status, msg);

      trackEvent("ai_card_builder_message_sent", { message });
      setMessage("");
    } catch (e) {
      showToast(false, "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // When you want to continue to AddNewCard page (your existing flow)
  const handleContinueToCardBuilder = () => {
    const query = new URLSearchParams();

    // keep same params style you already use
    if (dynamicQRCodeId) query.set("dynamic_qr_code", dynamicQRCodeId);
    if (teamId || team_id || userTeamId)
      query.set("team_id", teamId || team_id || userTeamId);
    if (userId || user_id) query.set("user_id", userId || user_id);

    navigate(`/function/cardfunctions${query.toString() ? `?${query}` : ""}`, {
      state: {
        fromAI: true,
        teamId,
        userId,
        team_id,
        user_id,
        dynamicQRCodeId,
      },
    });
  };

  return (
    <>
      {!loading ? (
        <div className="ai-page-wrapper">
          {/* Breadcrumb like your Card page */}
          <div className="row align-items-center mb-4">
            <div className="col-12">
              <div className="heading">
                <h1 className="mb-0">
                  <Link to="/" className="function-link">
                    Functions
                  </Link>
                  {` > `}
                  <span
                    className="function-link"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(-1)}
                  >
                    Cards
                  </span>
                  {` > AI Card Builder`}
                </h1>
              </div>
            </div>
          </div>

          <div className="ai-builder-page">
            <div className="ai-builder-content">
              <h2 className="ai-title">
                Let&apos;s build your digital Card, <span>{pageUserName}</span>
              </h2>
              <p className="ai-subtitle">
                AI will help you create your personalized business card
              </p>

              <div 
                className="ai-chatbox"
                role="button"
                tabIndex={0}
                onClick={() => {
                  navigate("/function/cards/ai-card-chat", {
                    state: { pageUserName }, // only pass name
                  });
                }}
                onKeyDown={(e) =>
                  e.key === "Enter" && e.currentTarget.click()
                }
              >
                <div className="ai-chat-header">
                  <div className="ai-chat-title ai-title-input">
                    <b>Hi 👋, I am Link</b>, ask me to create your card step by
                    step..
                  </div>
                </div>

                <div className="ai-chat-body">
                  <div className="ai-empty-hint">
                    Type a message like: “Create a business card for me with
                    name, email, company…”
                  </div>
                </div>

                <div className="ai-chat-footer">
                  <Button variant="outline-success" className="ai-attach-btn">
                    <FiPaperclip /> <span>Attach</span>
                  </Button>

                  <div className="ai-input-wrap">
                    {/* <button className="ai-icon-btn" type="button">
                      <FiMic />
                    </button> */}

                    <button
                      className="ai-send-btn"
                      type="button"
                      onClick={handleSend}
                      aria-label="Send"
                    >
                      <FiArrowUp />
                    </button>
                  </div>

                  <div className="ai-actions">
                    <Button
                      variant="link"
                      className="ai-back-btn"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </Button>

                    <Button
                      variant="primary"
                      className="ai-next-btn"
                      onClick={handleContinueToCardBuilder}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default AiCardBuilder;
